<template>
  <div class="input">
    <div class="input-label">支店名</div>
    <div class="input-group">
      <input type="text" class="input-text" v-model="branchName">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    branchName: {
      get: function () {
        return this.$store.state.bank.branchName
      },
      set: function (value) {
        this.$store.commit(
          'bank/setBranchName',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss'
</style>
